<template>
  <div>
    <navTitle path="/user" title="Bind phone number"></navTitle>
    <div class="ChangePassword" style="margin-top: 1rem">
      <div class="list">
        <div class="item">
          <span class="chooseArea" @click="chooseArea()">
            <slot name="country_tel">+{{ area }}</slot>
            <span
              ><svg
                t="1566640213388"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2787"
                width="18"
                height="18"
              >
                <path
                  d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                  p-id="2788"
                ></path></svg
            ></span>
          </span>
          <input type="number" placeholder="Enter your phone number" v-model="phone" />
        </div>
        <div class="item acea-row row-between-wrapper">
          <input
            type="text"
            placeholder="verification code"
            class="codeIput"
            v-model="captcha"
          />
          <button
            class="code font-color-red"
            :disabled="disabled"
            :class="disabled === true ? 'on' : ''"
            @click="code"
          >
            {{ text }}
          </button>
        </div>
      </div>
      <div class="confirmBnt bg-color-red" @click="confirm">Confirm bind</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import navTitle from "@components/navTitle";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone } from "@api/user";

export default {
  name: "BindingPhone",
  components: {
    navTitle
  },
  props: {},
  data: function() {
    return {
      area: "",
      captcha: "",
      phone: "" //手机号
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.area = this.localStorage.get("Area")
      ? this.localStorage.get("Area")
      : this.localStorage.get("default_country_code");
  },
  watch: {
    $route() {
      // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
      this.area = this.localStorage.get("Area")
        ? this.localStorage.get("Area")
        : this.localStorage.get("default_country_code");
    }
  },
  methods: {
    chooseArea: function() {
      this.$router.push({ path: "/selectCode" });
    },
    async confirm() {
      let that = this;
      const { phone, captcha } = that;
      try {
        await that
          .$validator({
            phone: [
              chs_phone(chs_phone.message("phone")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("code")),
              alpha_num(alpha_num.message("code"))
            ]
          })
          .validate({ phone, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      bindingPhone({
        phone: this.area + this.phone,
        captcha: this.captcha
      })
        .then(res => {
          that.$dialog.success(res.msg).then(() => {
            that.$router.replace({ name: "PersonalData" });
          });
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("phone")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: this.area + phone })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style>
.chooseArea {
  display: flex;
  line-height: 1.1rem;
}
</style>
